import { z } from 'zod';

export const exportProjectBySlugSchema = z.object({
  slug: z.string().min(1),
});

export type ExportProjectBySlugQuery = z.infer<
  typeof exportProjectBySlugSchema
>;

export type ExportProjectBySlugResponse = {
  name: string;
  description: string;
  country: string;
  repoLink: string | null;
  presentationLink: string | null;
  technicalDemoLink: string | null;
  twitterHandle: string | null;
  additionalInfo: string | null;
  contactEmail: string;
  hasReturningWinner: boolean;
  returningWinnerPrizes: Array<{
    name: string;
    placement: number;
    prizeAmount: number;
  }>;
  previousProjectPercentage: number;
  teamMembers: Array<{
    displayName: string;
    username: string;
    about: string;
    githubHandle: string | null;
    linkedinHandle: string | null;
    telegramHandle: string | null;
    twitterHandle: string | null;
  }>;
  eternalWeeklyUpdates: Array<{
    updateNumber: number;
    updateUrl: string;
  }>;
};

export const findProjectsQuerySchema = z.object({
  name: z.string().optional(),
  slug: z.string().optional(),
});

export type FindProjectsQuery = z.infer<typeof findProjectsQuerySchema>;

export type FindProjectsResponse = {
  projects: {
    id: number;
    name: string;
    slug: string;
    description: string;
    country: string;
    repoLink: string | null;
    presentationLink: string | null;
    twitterHandle: string | null;
    additionalInfo: string | null;
    ownerId: number;
    submittedAt: Date | null;
    hackathonId: number | null;
    eternalChallengeId: number | null;
    hackathonName: string | null;
    eternalChallengeName: string | null;
    teamMembers: Array<{
      displayName: string;
      username: string;
      about: string;
      githubHandle: string | null;
      linkedinHandle: string | null;
      telegramHandle: string | null;
      twitterHandle: string | null;
    }>;
  }[];
};
